import React from 'react';
import { FormattedMessage } from "react-intl";

// @mui/material components
import {makeStyles, withStyles} from '@mui/styles';

// style
import { primaryColor } from "../../../assets/jss/main";
import rowStyle from "../../../assets/jss/views/cancellationReason/rowStyle";

const useStyles = makeStyles(theme => ({
    tableHeadContainer:{
        display: "flex",
        justifyContent: "space-between",
        width: "100%"
    },
    headContainer:{
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
    },
    primaryTableHeader: {
        color: primaryColor,
        fontSize: "16px",
        fontWeight: "400",
    },
}));

function EnhancedTableHead (props) {
    const componentClasses = useStyles();
    const { classes } = props;

    const headers = [
        {
            translation: "cancellation_reason.table.header.name",
            sizeClass: "two",
        },
        {
            translation: "cancellation_reason.table.header.status",
            sizeClass: "two",
        },
        {
            translation: "cancellation_reason.table.header.transition",
            sizeClass: "two",
        },
        {
            translation: "cancellation_reason.table.header.scope",
            sizeClass: "one",
        },
        {
            translation: "cancellation_reason.table.header.refund",
            sizeClass: "two",
        },
        {
            translation: "cancellation_reason.table.header.enabled",
            sizeClass: "one",
        },
        {
            translation: "cancellation_reason.table.header.actions",
            sizeClass: "one",
        },
    ];

    return (
        <div className={componentClasses.tableHeadContainer}>
            <div className={componentClasses.headContainer}>
                {headers.map((header, index) => (
                    <div key={index} className={componentClasses.primaryTableHeader + ' ' + classes[header.sizeClass]}>
                        <FormattedMessage id={header.translation} />
                    </div>
                ))}
            </div>
        </div>
    );
}
export default withStyles(rowStyle)(EnhancedTableHead);
